const addSkipBtn = () => {
  const playerInstance = jwplayer();

  playerInstance.addButton(
    `<svg class="jw-svg-icon jw-svg-icon-rewind" fill="rgba(255, 255, 255, 0.8)" version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
\t x="0px" y="0px" viewBox="0 0 240 240" style="enable-background:new 0 0 240 240;" xml:space="preserve">
<path d="M193.6,131.1c-3.7-6.3-10.4-10.3-17.7-10.6c-7.3,0.3-14,4.3-17.7,10.6c-8.6,14.2-8.6,32.1,0,46.3
\tc3.7,6.3,10.4,10.3,17.7,10.6c7.3-0.3,14-4.3,17.7-10.6C202.2,163.1,202.2,145.3,193.6,131.1z M175.9,178.3
\tc-7.8,0-14.4-11-14.4-24.1c0-13.1,6.6-24.1,14.4-24.1c7.8,0,14.4,11,14.4,24.1C190.3,167.3,183.8,178.3,175.9,178.3z"/>
<path d="M132.5,188v-51l-4.8,4.8l-6.8-6.8l13-13c1.9-1.9,4.9-1.9,6.8,0c0.9,0.9,1.4,2.1,1.4,3.4v62.7L132.5,188z"/>
<path d="M30.9,52.9H161V33.6c0-5.3,3.6-7.2,8-4.3l41.8,27.9c1.2,0.6,2.1,1.5,2.7,2.7c1.4,3,0.2,6.5-2.7,8L169,95.8
\tc-4.4,2.9-8,1-8-4.3V72.2H45.3v96.4h48.2v19.3H30.8c-2.6,0-4.8-2.2-4.8-4.8V57.8C26,55.1,28.2,52.9,30.9,52.9z"/>
</svg>`,
    '10초 빨리감기',
    () => {
      playerInstance.seek(playerInstance.getPosition() + 10);
    },
    'jw-icon-forward',
  );

  // setControls(true) 호출 시 컨트롤바 DOM이 재구성되므로
  // 매번 새로 쿼리하여 show 클래스 추가 + 위치 재배치
  const attachSkipButtons = () => {
    const rewindIcon = document.querySelector('.jw-icon-inline.jw-icon-rewind') as HTMLElement | null;
    const forwardIcon = document.querySelector('div[button="jw-icon-forward"]') as HTMLElement | null;
    const playIcon = document.querySelector('.jw-icon-inline.jw-icon-playback') as HTMLElement | null;
    if (!rewindIcon || !forwardIcon || !playIcon) return false;

    rewindIcon.classList.add('show');
    playIcon.parentNode.insertBefore(rewindIcon, playIcon);
    playIcon.parentNode.insertBefore(forwardIcon, playIcon.nextSibling);
    return true;
  };

  const ensureInitialAttach = () => {
    let tries = 0;
    const maxTries = 10;
    const timer = setInterval(() => {
      const attached = attachSkipButtons();
      tries += 1;
      if (attached || tries >= maxTries) {
        clearInterval(timer);
      }
    }, 300);
  };
  ensureInitialAttach();

  // 컨트롤바 재구성 감지 시 버튼 재부착
  const container = (playerInstance.getContainer?.() as HTMLElement) || document.body;
  const mo = new MutationObserver(() => {
    mo.disconnect();
    attachSkipButtons();
    try {
      mo.observe(container, { childList: true, subtree: true });
    } catch (_) { /* noop */ }
  });
  try {
    mo.observe(container, { childList: true, subtree: true });
  } catch (_) {
    // 관찰 실패 시에도 기능은 동작하므로 무시
  }
};

export default addSkipBtn;
